import React from "react";
import ClipboardIcon from '../common/ClipboardIcon/ClipboardIcon';
import './agent0d365attributes.css'

export const Agent0D365AttributesMessage = (props) => {
    const {contactAgent0D365Attributes} = props;

    const handleCopy = async (text) => {
        try {
        await navigator.clipboard.writeText(text);
        } catch (err) {
            console.error("Failed to copy:", err);
        }
    };

    return <>
        {
            <div className="row message-left">
                <div className="col-md-9">
                    <div className="message-left-body agent0d365-attributes">
                        {contactAgent0D365Attributes?.hcProUserId &&
                            <>
                                <div className="agent0d365-attributes__label">
                                    HCPro User ID:
                                </div>
                                <div className="agent0d365-attributes__value">
                                    {contactAgent0D365Attributes?.hcProUserId}
                                </div>
                            </>
                        }
                        {contactAgent0D365Attributes?.platform && 
                            <>
                                <div className="agent0d365-attributes__label">
                                    Platform:
                                </div>
                                <div className="agent0d365-attributes__value">
                                    {contactAgent0D365Attributes?.platform}
                                </div>
                            </>
                        }
                        {contactAgent0D365Attributes?.customerPhoneNumber && 
                            <>
                                <div className="agent0d365-attributes__label">
                                    Customer Phone Number:
                                </div>
                                <div className="agent0d365-attributes__value">
                                    {contactAgent0D365Attributes?.customerPhoneNumber}
                                </div>
                            </>
                        }
                        {contactAgent0D365Attributes?.accountName && 
                            <>
                                <div className="agent0d365-attributes__label">
                                    Account Name:
                                </div>
                                <div className="agent0d365-attributes__value">
                                    {contactAgent0D365Attributes?.accountName}
                                </div>
                            </>
                        }
                        {contactAgent0D365Attributes?.d365TicketId && 
                            <>
                                <div className="agent0d365-attributes__label">D365 Ticket ID:</div>
                                <div className="agent0d365-attributes__value">
                                    {contactAgent0D365Attributes?.d365TicketId}

                                    <button 
                                        onClick={() => handleCopy(contactAgent0D365Attributes?.d365TicketId)} 
                                        className="agent0d365-attributes__copy"
                                    >
                                        <ClipboardIcon />
                                    </button>
                                </div>   
                            </>
                        }
                        {contactAgent0D365Attributes?.d365SSOLink && 
                            <>
                                <div className="agent0d365-attributes__label">SSO to D365:</div>
                                <div className="agent0d365-attributes__value">
                                    <div className="agent0d365-attributes__wrap-ellipsis">
                                        <a 
                                            href={contactAgent0D365Attributes?.d365SSOLink} 
                                            target="_blank"
                                            className="agent0d365-attributes__link"
                                        >
                                            {contactAgent0D365Attributes?.d365SSOLink}
                                        </a>
                                    </div>

                                    <button 
                                        onClick={() => handleCopy(contactAgent0D365Attributes?.d365SSOLink)} 
                                        className="agent0d365-attributes__copy"
                                    >
                                        <ClipboardIcon />
                                    </button>
                                </div>
                                
                            </>
                        }
                    </div>
                </div>
                <div className="col-md-3">
                </div>
            </div>
        }
    </>;
}
